<style lang="css" scoped>

	.logo {
		max-height: 180px;
		max-width: 180px;
		width: 180px;
		margin-bottom: 0px;
	}
	#topPart {
		min-height: 15vh;
	}
	#middlePart {
		min-height: 70vh;
	}
	#bottomPart {
		min-height: 10vh;
	}
	#helpBtn {
		height: 90vw;
		width: 90vw;
		max-height: 350px;
		max-width: 350px;
		margin: 0 auto;
		font-size: 3em;
		border-radius: 100%;
	}
	#cancelHelp {
		font-size: 2em;
	}

</style>

<template>

	<v-container class="px-0 py-1 mb-0">
		<v-layout column wrap class="">
			<v-flex shrink id="topPart">
				<v-layout row wrap justify-space-between>
					<v-flex grow>
						<v-img :src="`../images/logo.svg`" class="transparent logo pointer mx-auto" @click="$router.push('/')"></v-img>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex grow id="middlePart">
				<v-layout v-show="!help" row wrap>
					<v-flex xs12>
						<heartbeat :selectedDevice="selectedDevice" @firstDevice="selectedDevice = 0" @secondDevice="selectedDevice = 1" />
					</v-flex>
					<v-flex xs12>
						<v-layout row wrap justify-space-around class="pt-2">
							<v-flex d-flex shrink align-center>
								<v-btn color="blue"
								       class="white--text"
								       ripple
								       round
								       :depressed="selectedDevice == 0"
								       :outline="selectedDevice == 1"
								       :small="selectedDevice == 1"
								       @click="selectedDevice = 0">צמיד 1</v-btn>
							</v-flex>
							<v-flex d-flex shrink align-center>
								<v-btn color="blue"
								       class="white--text"
								       ripple
								       round
								       :depressed="selectedDevice == 1"
								       :outline="selectedDevice == 0"
								       :small="selectedDevice == 0"
								       @click="selectedDevice = 1">צמיד 2</v-btn>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout v-if="help && !helping" row wrap>
					<v-flex xs12>
						<v-btn id="helpBtn" fab round color="red" dark block large @click="getHelp">קריאה לעזרה!</v-btn>
					</v-flex>
				</v-layout>
				<v-layout v-else-if="help && helping" row wrap>
					<v-flex xs12 class="display-4 red--text text-xs-center">
						העזרה בדרך!
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex shrink class="mt-3">
				<v-layout row wrap justify-space-between>
					<v-flex grow>
					</v-flex>
					<v-flex grow>
						<v-btn v-if="!help" round color="red" dark block @click="help = true">קריאה לעזרה</v-btn>
						<v-btn v-else color="secondary" id="cancelHelp" flat block large @click="cancel">ביטול</v-btn>
					</v-flex>
					<v-flex grow>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>

</template>

<script>

	import Heartbeat from './heartbeat';
	export default {
		components: {
			Heartbeat
		},
		props: ['locale', 'dir'],
		data() {
			return {
				selectedDevice: 0,
				help: false,
				helping: false,
				loadInterval: false
			};
		},
		methods: {
			sidebar() {
				EventBus.$emit('sidebar', true);
			},
			getHelp(){
				this.helping = true;
				// axios.get(
				//   '/api/get-elp'
				// ).then(res => {
				//   console.log(res);
				// }).catch(err => {
				//   console.log(err);
				// })
			},
			cancel() {
				this.help = false;
				this.helping = false;
			},
			setLang() {
				if (this.locale == 'en') {
					this.content = {
						not_connected: 'Not Connected',
						no_sensor: 'Sensor is not connected',
						exceeds: 'Exceeds the threshold',
						sensor_close: 'Warning of flooding!',
						magnet_true: 'Detects a magnet nearby',
						magnet_false: 'A magnet is not detected',
						empty: {
							title: "You don't have any switches registered yet!",
							subtitle: 'Click here to register a new switch',
							btn: 'New Switch'
						}
					};
				} else if (this.locale == 'he') {
					this.content = {
						not_connected: 'לא מחובר',
						no_sensor: 'חיישן אינו מחובר',
						exceeds: 'חורג מהסף',
						sensor_close: 'אזהרת הצפה!',
						magnet_true: 'מזהה מגנט קרוב',
						magnet_false: 'לא מזהה מגנט',
						empty: {
							title: 'עדיין לא רשומים אצלך מכשירים!',
							subtitle: 'לחץ כאן כדי לרשום מכשיר חדש',
							btn: 'מכשיר חדש'
						}
					};
				}
			}
		}
	};

</script>
